import { withKeys as _withKeys, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id", "name", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!

  return (_openBlock(), _createBlock(_component_FormField, {
    config: _ctx.config,
    "placeholder-state": _ctx.placeholderState,
    "error-state": _ctx.state.errors !== null,
    onSubmitAction: _ctx.handleSubmit
  }, {
    default: _withCtx(() => [
      _createElementVNode("input", {
        class: "a-formInput",
        type: "text",
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleFocusChange(true))),
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleFocusChange(false))),
        onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["enter"])),
        id: _ctx.config.name,
        name: _ctx.config.name,
        value: _ctx.elementValue
      }, null, 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["config", "placeholder-state", "error-state", "onSubmitAction"]))
}